export const emptyObject = {};

export const STATE_KEYS = {
  AUTH: 'auth',
  LOGOUT: 'logout',
  PASSWORD: 'password',
  LOGIN: 'login',
  REGISTRATION: 'registration',
};
